import { render, staticRenderFns } from "./editdialog.vue?vue&type=template&id=31a922c2&scoped=true"
import script from "./editdialog.vue?vue&type=script&lang=js"
export * from "./editdialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31a922c2",
  null
  
)

export default component.exports